'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { type DevelopedFeatures } from './constants';
export const useFeatureFlags = () => {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [enabledFeatures, setEnabledFeatures] = useState(t0);
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const fetchValue = async () => {
        const response = await fetch("/api/feature-flags/enabled");
        if (response.ok) {
          const responseJson = await response.json();
          setEnabledFeatures(responseJson.value);
        }
      };
      fetchValue();
    };
    t2 = [];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== enabledFeatures) {
    t3 = featureKey => enabledFeatures?.includes(featureKey);
    $[3] = enabledFeatures;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const getIsFeatureEnabled = t3;
  let t4;
  if ($[5] !== enabledFeatures || $[6] !== getIsFeatureEnabled) {
    t4 = {
      enabledFeatures,
      getIsFeatureEnabled
    };
    $[5] = enabledFeatures;
    $[6] = getIsFeatureEnabled;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};